/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import CheckboxUncontrolled from "../ui/form/CheckboxUncontrolled";
import Text from "../ui/Text";
import FormatPrice from "../formatters/FormatPrice";
import FormatDateTime from "../formatters/FormatDateTime";
import { useTranslate } from "../../hooks/useTranslate";
import { formatRecurringPeriod } from "../../utils/helpers/membership";

const Box = styled.div`
  display: inline-flex;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  border-radius: 0.5rem;
  background: rgba(${({ theme }) => theme.colors.accent.rgb}, 0.05);
  text-wrap: auto;
`;

const LabelBlock = styled.div`
  display: grid;
  gap: 2px;
`;

const AutoRenewMembershipOption = ({
  checked,
  onChange,
  recurringPrice,
  currency,
  duration,
  durationType,
  endDate,
}) => {
  const { _t } = useTranslate();

  return (
    <Box>
      <CheckboxUncontrolled name="auto_renew_membership" defaultValue={checked} onChange={onChange}>
        <LabelBlock>
          <Text as="span" color="dark">
            {_t("Auto-renew")} ·{" "}
            <FormatPrice value={recurringPrice} currency={currency} />/
            {formatRecurringPeriod(duration, durationType, _t)}
          </Text>
          {endDate && (
            <Text as="span" size="small">
              {_t("Otherwise this membership ends on")}{" "}
              <FormatDateTime value={endDate} format={FormatDateTime.FORMAT.DATE} />
            </Text>
          )}
        </LabelBlock>
      </CheckboxUncontrolled>
    </Box>
  );
};

export default AutoRenewMembershipOption;
